import { useState } from "react";
import ItemsILove from "../components/profile/ItemsILove";
import ProfileHeader from "../components/profile/ProfileHeader";
import MyStore from "../components/profile/MyStore";

const Profile = () => {
  const [currentComponent, setCurrentComponent] = useState("items i love");
  return (
    <div className={`bg-slate-100 min-h-screen pb-10 md:pb-48 relative`}>
      <ProfileHeader />
      <div className="flex gap-6 justify-center border-b border-label mt-5 md:mt-3">
        {/* <button>My orders</button> */}
        <button
          className={`${
            currentComponent === "items i love"
              ? "font-bold text-black border-b-[3px] border-logoRed"
              : "font-normal text-label"
          } pb-2`}
          onClick={() => setCurrentComponent("items i love")}
        >
          Items i love
        </button>

        <button
          className={`${
            currentComponent === "my store"
              ? "font-bold text-black border-b-[3px] border-logoRed"
              : "font-normal text-label"
          } pb-2`}
          onClick={() => setCurrentComponent("my store")}
        >
          My store
        </button>
      </div>

      {currentComponent === "items i love" ? <ItemsILove /> : <MyStore />}
    </div>
  );
};

export default Profile;
